export default __webpack_public_path__ + "static/media/partners-popup-video.744253a3.mp4";